
import { Component, Vue } from 'vue-property-decorator'
import { CardDynamicClient } from '@/api'
import BaseList from '@/views/BaseList'
import _ from 'lodash'
import { setTimeout } from 'timers'
import moment from 'moment'
@Component({
  name: 'CardDynamicList',
  components: {
  }
})
export default class extends BaseList {
  public constructor() {
    super()
    this.client = new CardDynamicClient()
    this.listQuery = {
      filter: {
        where: {
          card_number: { like: '' },
          createdAt: { begin: undefined, end: undefined },
          companyId: this.$store.state.user.companyId
        },
        fields: {
          id: true,
          companyId: true,
          cardId: true,
          card_number: true,
          volume: true,
          gasType: true,
          gasPrice: true,
          floating_ratio: true,
          out: true,
          in: true,
          balance: true,
          description: true,
          createdAt: true
        },
        include: [
          { relation: 'company' },
          { relation: 'card' },
          { relation: 'stationDynamic' }
        ],
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt desc']
      }
    }
  }

  async created() {
    super.created()
  }

  protected generateQuery():any {
    const t = _.cloneDeep(this.listQuery)
    const and = []

    and.push({ companyId: this.$store.state.user.companyId })

    if (!_.isNil(t.filter.where.card_number) && !_.isEmpty(t.filter.where.card_number)) {
      and.push({ card_number: { like: `%${t.filter.where.card_number.like}%` } })
    }

    const createdAt = t.filter.where.createdAt
    if (createdAt.begin) {
      and.push({ createdAt: { gte: moment(createdAt.begin).utcOffset(480) } })
    }

    if (createdAt.end) {
      and.push({ createdAt: { lt: moment(createdAt.end).utcOffset(480) } })
    }

    t.filter.where = { and }
    return t
  }

  protected generateQuery2():any {
    const t = _.cloneDeep(this.listQuery)
    t.filter.where.card_number.like = `%${t.filter.where.card_number.like}%`
    const createdAt = t.filter.where.createdAt
    if (createdAt.begin && createdAt.end) {
      t.filter.where.createdAt = { gte: createdAt.begin, lt: createdAt.end }
    } else if (createdAt.begin) {
      t.filter.where.createdAt = { gte: createdAt.begin }
    } else if (createdAt.end) {
      t.filter.where.createdAt = { lt: createdAt.end }
    } else {
      t.filter.where.createdAt = undefined
    }
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val:number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val:number) {
    super.handleCurrentChange(val)
  }

  protected handleDownload() {
    this.listLoading = true
    const header = ['订单编号', '卡号', '车辆', '加气类型', '加气量', '浮动比例', '气价', '收入', '支出', '账户余额', '备注', '时间']
    const filterVal = ['stationDynamic.id', 'card_number', 'stationDynamic.plate_number', 'gasType', 'volume', 'floating_ratio', 'gasPrice', 'in', 'out', 'balance', 'description', 'createdAt']
    const data = _.union([header], this.formatJson(filterVal, this.list))
    this.exportXlsx(data)
    this.listLoading = false
  }

  protected formatJson(filterVal :any, jsonData:any) {
    const data = jsonData.map((v:any) => filterVal.map((j:any) => {
      if (j === 'createdAt') {
        return this.parseTime(v[j])
      } else if (j === 'stationDynamic.id') {
        if (v['stationDynamic']) {
          return v['stationDynamic']['id']
        } else {
          return ''
        }
      } else if (j === 'stationDynamic.plate_number') {
        if (v['stationDynamic']) {
          return v['stationDynamic']['plate_number'] || '—'
        } else {
          return '—'
        }
      } else {
        return v[j]
      }
    }))
    return data
  }
}
